import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Container,
  FloatingLabel,
  FormControl,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import ApiService from "../../../services/api";

const NewsList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [news, setNews] = useState([]);
  const [filtredNews, setFiltredNews] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchNews = async () => {
    const News = await ApiService.getNews();
    setNews(News.sort((a, b) => b.id - a.id));
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    const filtered = news.filter(
      (item) =>
        (item.category.name &&
          item.category.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (item.title &&
          item.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (moment(item.date).format("DD-MM-YYYY HH:mm") &&
          moment(item.date).format("DD-MM-YYYY HH:mm").includes(searchTerm))
    );
    setFiltredNews(filtered);
  }, [searchTerm, news]);

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
  };

  const deleteNews = useCallback(
    async (slug) => {
      const confirmed = window.confirm(
        "Sei sicuro di voler eliminare questa notizia?"
      );
      if (confirmed) {
        try {
          await ApiService.deleteNews(slug);
          setNews((prev) => prev.filter((item) => item.slug !== slug));
        } catch (e) {
          console.log("Errore durante l'eliminazione della news");
        }
      }
    },
    [news]
  );

  const paginationOptions = {
    rowsPerPageText: "Elementi per pagina",
    rangeSeparatorText: "di",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Tutti",
  };

  const columns = [
    {
      name: "Creato il",
      sortable: true,
      selector: (row) => moment(row.date).format("DD-MM-YYYY"),
      center: "true",
      width: "25%",
    },
    {
      name: "Categorie",
      selector: (row) => row.category.name,
      center: "true",
      width: "25%",
    },
    {
      name: "Titolo",
      selector: (row) => row.title,
      center: "true",
      width: "25%",
    },
    {
      name: "Azioni",
      width: "25%",
      center: "true",

      cell: (row) => (
        <>
          <Link to={`/admin/newsList/${row.slug}`}>
            <Button variant="link" className="text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-pencil-square me-1 text-primary"
                viewBox="0 0 16 16"
              >
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
              </svg>{" "}
            </Button>
          </Link>
          <Button
            variant="link"
            className="text-danger"
            onClick={() => deleteNews(row.slug)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-x-square ms-1 text-danger"
              viewBox="0 0 16 16"
            >
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </Button>
        </>
      ),
    },
  ];

  if (Loading) {
    return;
  }

  return <>
    <Container fluid className="p-0 m-0 text_data_admin px-2">
      <nav aria-label="breadcrumb ">
        <ol className="breadcrumb pb-5 ps-5">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            News
          </li>
        </ol>
      </nav>
    </Container>
    <Row>
      <Col lg="12" className="mb-5 pb-5">
        <div className="admin-card">
          <div className="admin-card-header">
            <div className="admin-card-icon black-gradient">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-megaphone-fill" viewBox="0 0 16 16">
                <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z" />
              </svg>
            </div>
            <p><small>News</small></p>
          </div>

          <div className=" mt-4 ms-3">
            <div className="w-100">
              <Link
                to="/admin/newsCreate"
                className="btn btn-black-gradient text-white"
                data-discover="true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Inserisci news
              </Link>
            </div>
          </div>

          <div className="box_body_teams ps-3 py-4 text_size_data ">
            <FloatingLabel
              controlId="floatingInput"
              label="Cerca una news"
              className="mb-0 w-100"
            >
              <FormControl
                type="text"
                placeholder=" Cerca pagina"
                className="mr-sm-2"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </FloatingLabel>

          </div>

          <DataTable
            columns={columns}
            data={filtredNews}
            pagination
            paginationComponentOptions={paginationOptions}
            paginationPerPage={30}
          />
        </div>
      </Col>
    </Row>
  </>
};
export default NewsList;
